/**
 * 角色卡页坐标常量（T07）。
 * -----------------------------------------------------------------------------
 * 所有部件的布局都在此声明，页面只做「引用常量 → 渲染 + 登记」，
 * 保证同一份坐标既驱动视觉、又进组件清单。
 *
 * 坐标系：页面局部坐标（y = 0 是内容区顶部，内容区绝对起点为 y = 24）；
 * 登记时由 `Framed.tsx` 统一加上 `CONTENT_TOP` 换算成 390x844 画布绝对坐标。
 * ============================================================================= */

import type { BoxLayout } from '../../ui';

/** 内容区顶部安全区偏移（与 PhoneFrame 的 24dp 状态栏同源）。 */
export const CONTENT_TOP = 24;

/** 页面根容器：内容区 390 x 744。 */
export const PAGE_BOX: BoxLayout = { x: 0, y: 0, width: 390, height: 744 };

/* ---- 列表页 ------------------------------------------------------------- */

export const LIST_HEADER_BOX: BoxLayout = { x: 0, y: 0, width: 390, height: 56 };
export const LIST_TITLE_BOX: BoxLayout = { x: 16, y: 14, width: 160, height: 28 };
export const COMMUNITY_BUTTON_BOX: BoxLayout = { x: 190, y: 8, width: 100, height: 40 };
export const NEW_CONTACT_MENU_BOX: BoxLayout = { x: 266, y: 52, width: 108, height: 40 };
export const IMPORT_CARD_BUTTON_BOX: BoxLayout = { x: 266, y: 94, width: 108, height: 40 };
export const IMPORT_WORLD_BOOK_BUTTON_BOX: BoxLayout = { x: 266, y: 136, width: 108, height: 40 };
export const CREATE_BUTTON_BOX: BoxLayout = { x: 298, y: 8, width: 76, height: 40 };
export const LIST_BOX: BoxLayout = { x: 0, y: 60, width: 390, height: 684 };

/** 列表项几何：高 146，步进 158。 */
export const LIST_ITEM_HEIGHT = 146;
export const LIST_ITEM_STEP = 158;

/* ---- 编辑器页 ----------------------------------------------------------- */

export const EDITOR_HEADER_BOX: BoxLayout = { x: 0, y: 0, width: 390, height: 56 };
export const EDITOR_BACK_BOX: BoxLayout = { x: 8, y: 8, width: 44, height: 40 };
export const EDITOR_TITLE_BOX: BoxLayout = { x: 60, y: 16, width: 180, height: 24 };
export const EDITOR_SAVE_BOX: BoxLayout = { x: 290, y: 8, width: 92, height: 40 };
export const EDITOR_ERROR_BOX: BoxLayout = { x: 8, y: 58, width: 374, height: 26 };
export const EDITOR_NOTICE_BOX: BoxLayout = { ...EDITOR_ERROR_BOX };

/** 表单滚动区（标题栏之下）。 */
export const FORM_SCROLL_BOX: BoxLayout = { x: 0, y: 88, width: 390, height: 656 };
export const FORM_SCROLL_TOP = 88;

/** 表单字段槽位（页面局部坐标）。 */
export const FIELD_NAME_LABEL_BOX: BoxLayout = { x: 16, y: 104, width: 160, height: 16 };
export const FIELD_NAME_BOX: BoxLayout = { x: 16, y: 122, width: 358, height: 40 };
export const FIELD_AVATAR_LABEL_BOX: BoxLayout = { x: 16, y: 178, width: 160, height: 16 };
export const FIELD_AVATAR_BOX: BoxLayout = { x: 16, y: 196, width: 358, height: 40 };
export const MODEL_CONFIG_BUTTON_BOX: BoxLayout = { x: 16, y: 282, width: 358, height: 40 };
export const FIELD_TAGS_LABEL_BOX: BoxLayout = { x: 16, y: 338, width: 200, height: 16 };
export const FIELD_TAGS_BOX: BoxLayout = { x: 16, y: 356, width: 358, height: 40 };
export const FIELD_DESC_LABEL_BOX: BoxLayout = { x: 16, y: 412, width: 200, height: 16 };
export const FIELD_DESC_BOX: BoxLayout = { x: 16, y: 430, width: 358, height: 80 };
export const FIELD_PROMPT_LABEL_BOX: BoxLayout = { x: 16, y: 526, width: 220, height: 16 };
export const FIELD_PROMPT_BOX: BoxLayout = { x: 16, y: 544, width: 358, height: 150 };

/** 自动化与媒体位于提示词之后、世界书之前。 */
export const INTIMACY_TOP = 710;
export const AUTOMATION_TOP = INTIMACY_TOP + 88;
export const AUTOMATION_SECTION_HEIGHT = 716;
const WORLD_BOOK_TOP = AUTOMATION_TOP + AUTOMATION_SECTION_HEIGHT + 16;

/** 世界书区块（勿扰时段增加时，运行时整体下移）。 */
export const WORLD_BOOK_TITLE_BOX: BoxLayout = { x: 16, y: WORLD_BOOK_TOP, width: 134, height: 24 };
export const ADD_ENTRY_BUTTON_BOX: BoxLayout = { x: 270, y: WORLD_BOOK_TOP - 6, width: 104, height: 40 };
export const IMPORT_WORLD_BOOK_EDITOR_BOX: BoxLayout = { x: 158, y: WORLD_BOOK_TOP - 6, width: 104, height: 40 };
export const WORLD_BOOK_ENTRY_TOP = WORLD_BOOK_TOP + 52;
export const WORLD_BOOK_ENTRY_HEIGHT = 264;
export const WORLD_BOOK_ENTRY_STEP = 276;
